import React from 'react';
import { styled } from 'styled-components';
import { ImageContainer } from './ShowInfo.styles';
import { Viewports } from '../../../../../play-core/styles/Viewports';
import { desktopHeaderHeight, mobileHeaderHeight } from '../../../components/Header/Header.globals';
import { PlayImage } from '../../../components/Image/PlayImage';
import { useShowPageConfig } from '../../../providers/UiConfigProvider/UiConfigContext';
import { useViewport } from '../../../providers/ViewportProvider/ViewportContext';
import { jsx as _jsx } from "react/jsx-runtime";
export const useShowImageAndFrame = showDetail => {
  const pageConfig = useShowPageConfig();
  const {
    isMediumDown
  } = useViewport();
  const frameConfig = pageConfig.displayShowBackground?.find(show => show.showId === showDetail?.id);
  const Frame = frameConfig ? /*#__PURE__*/_jsx(StyledFrame, {
    "aria-hidden": true,
    children: /*#__PURE__*/_jsx(StyledImage, {
      src: frameConfig.imgSrc
    })
  }) : null;
  const Image = !frameConfig && showDetail ? /*#__PURE__*/_jsx(ImageContainer, {
    children: /*#__PURE__*/_jsx(PlayImage, {
      src: showDetail.imageUrl,
      alt: showDetail.title,
      aspectRatio: "16/9",
      width: 480,
      mediumImageWidth: 960,
      smallImageWidth: 320,
      hasBorderRadius: !isMediumDown
    })
  }) : null;
  return {
    Frame,
    Image
  };
};
const StyledFrame = styled.div.withConfig({
  displayName: "use-show-image-and-frame__StyledFrame",
  componentId: "sc-1n9ngud-0"
})(["width:100%;height:calc(100% - ", "px);position:fixed;top:", "px;left:0;z-index:-1;overflow-y:hidden;", "{top:", "px;height:calc(100% - ", "px);}"], desktopHeaderHeight, desktopHeaderHeight, Viewports.for('small'), mobileHeaderHeight, mobileHeaderHeight);
const StyledImage = styled.img.withConfig({
  displayName: "use-show-image-and-frame__StyledImage",
  componentId: "sc-1n9ngud-1"
})(["width:100%;height:auto;"]);